import queryString from 'querystringify';
import { useMemo } from 'react';
import {
    useLocation,
    useMatch,
    useNavigate,
    useParams,
} from 'react-router-dom';

export const useRouter = () => {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const match = useMatch;

    /**
     * Return our custom router object. Memoize so that a new object is only
     * returned if something changes.
     */
    return useMemo(() => {
        return {
            /** For convenience add push(), replace(), pathname at top level */
            pathname: location.pathname,
            /**
             * Merge params and parsed query string into single "query" object
             * so that they can be used interchangeably.
             * Example: /:topic?sort=popular -> { topic: "react", sort: "popular" }
             */
            query: {
                ...queryString.parse(location.search), // Convert string to object
                ...params,
            },
            /**
             * Include match, location, navigate objects so we have
             * access to extra React Router functionality if needed.
             */
            // match,
            location,
            navigate,
            match,
        };
    }, [params, match, location, navigate]);
};
